import {
    connect,
    injectReducer,
    injectSaga,
} from '@vfde-fe/sails_core';
import { WEBCHAT_TECHNICAL_ERROR } from 'Constant';
import { NAMESPACE } from './constants';
import { renderChatBubbles } from 'Container/Ui/helpers/renderWebchatBubbles';

import { createStructuredSelector } from 'reselect';
import initWebchatReducer from './reducer';
import initWebchatSaga from './sagas';
import { selectErrorCode } from './selector';

import { RootState } from './types';
import { mountLoadingAnimation } from '../../components/loadingAnimation';

function initWebchat (_state, _actions) {

    injectReducer(NAMESPACE, initWebchatReducer);
    injectSaga(NAMESPACE, initWebchatSaga);

    return {
        /**
         * This function is called on first load and everytime the store changes.
         * @param newState
         * @param oldState
         */
        getDerivedStateFromProps (newState, oldState) {

            if (newState.error && (newState.error !== oldState.error)) {

                renderChatBubbles([WEBCHAT_TECHNICAL_ERROR], false);

                mountLoadingAnimation().hide();
            }
        },
    };

}

/**
 * mapStateToProps = We are mapping the given states to props mapDispatch
 */
const mapStateToProps = createStructuredSelector<RootState, {}>({
    error: selectErrorCode(),
});

/**
 * mapDispatch = We are mapping the given action dispatch function to props Result.
 * You can use the states and dispatches as a prop in the main function
 */
const mapDispatch = {};

const InitWebchat = connect(mapStateToProps, mapDispatch)(initWebchat);

export default InitWebchat;
